 
// @mui material components
import Grid from "@mui/material/Grid"; 

// Material Dashboard 2 React components
 

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState } from "react";
 

// Data
 
// import CreateSession from "./CreateSession";
import UsersTable from "./UsersTable";
function ManageUsers() {
   

 
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={6}>
        <Grid item xs={12}>
        </Grid>
        <Grid item xs={12}>
          <UsersTable />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default ManageUsers;
